SupportIntermediateView = require('../views/intermediate_view')
SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels')
SupportLiveChatModel = require('../models/live_chat')
SupportLiveChatView = require('../views/live_chat_view')
SupportOrdersCollection = require('../collections/orders')
SupportOrderModel = require('../models/order')
SupportTicketSuccessView = require('../views/ticket_success_view')
SupportProblemSolvedView = require('../views/problem_solved_view')
SupportChatSuccessView = require('../views/chat_success_view')

class SupportHorizontalViewManagerBase
  constructor:  ->
    @configureContentModel()
    @configureOptimizedContactChannelsModel()
    @configureFlexibleContentChannelsModel()
    @initLiveChat()
    Groupon.Support.OrdersCollection = new SupportOrdersCollection()
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter()
    Groupon.Support.OrderModel = new SupportOrderModel()

  show: (view, params) ->
    @setCurrentView(view)
    Groupon.Support.CURRENTVIEW.render(params)
    $('#help-wizard').html(Groupon.Support.CURRENTVIEW.el)
    toggleCallUs(Groupon.Support.CURRENTVIEW.id)
    $(window).scrollTop(0)

  removeElement: (view) ->
    view.remove()

  setCurrentView: (view) ->
    if Groupon.Support.CURRENTVIEW?
      @removeElement(Groupon.Support.CURRENTVIEW)
    Groupon.Support.CURRENTVIEW = view

  render: ->

  renderIntermediateView: ->
    if $('#intermediate_page').length > 0
      intermediateView = new SupportIntermediateView(el: $('#intermediate_page'))
    else
      intermediateView = new SupportIntermediateView()
      intermediateView.render()
      $("#intermediate-page-container").html(intermediateView.el)

  renderOrders:  ->
    stepOneView = @getStepOneView()
    @show(stepOneView)

  renderOrderDetails: (order) ->
    stepOneView = @getStepOneView()
    @show(stepOneView, {order: order})

  renderDropDowns:  ->
    stepTwoView = @getStepTwoView()
    @show(stepTwoView)

  renderContactChannels: ->
    stepThreeView = @getStepThreeView()
    @show(stepThreeView)
    stepThreeView.postRenderhandler()
    stepThreeView

  ticketSuccess: ->
    @show(new SupportTicketSuccessView)

  chatSuccess: ->
    @show(new SupportChatSuccessView)

  renderProblemSolved: ->
    @show(new SupportProblemSolvedView)

  getStepOneView: ->

  getStepTwoView: ->

  getStepThreeView: ->

  configureContentModel: ->

  configureOptimizedContactChannelsModel: ->

  renderUserSignIn: (options)->

  configureFlexibleContentChannelsModel: ->
    Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel

  initLiveChat: ->
    Groupon.Support.LiveChatModel = new SupportLiveChatModel()
    Groupon.Support.LiveChatView = new SupportLiveChatView {model: Groupon.Support.LiveChatModel}

module.exports = SupportHorizontalViewManagerBase
